<template>
  <b-row>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="xl"
      title="Edição da carga"
      @dicard="hideModal"
    >
      <cargo-edit-data
        ref="cargoEditData"
        :cargo.sync="model"
        :id="id"
        :modal="true"
        :modelstate="modelstate"
        :permission="permissions"
        @confirmEdit="confirmEdit"
      ></cargo-edit-data>
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button
            class="ml-2"
            variant="green"
            @click="save($event)"
            :disabled="submitted"
          >
            {{ $t("geral.save") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-row>
</template>
<script>
export default {
  name: "CargoEditModal",
  props: {
    id: String,
    cargo: Object,
  },
  components: {
    CargoEditData: () =>
      import("@/components_rms/tracking/cargo/CargoEditData.vue"),
  },
  created() {
    this.model = this.cargo;
  },
  data() {
    return {
      permissions: 0,
      modelstate: {},
      submitted: false,
      model: {},
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },

    save(e) {
      this.submitted = true;
      this.$refs.cargoEditData.save(e);
      this.submitted = false;
      e.preventDefault();
    },
    hideModal() {
      this.$refs.openModal.hide();
    },
    confirmEdit() {
      this.hideModal();
      this.$emit("confirmEdit");
    },
  },
  watch: {
    model() {
      this.$emit("update:cargo", this.model);
    },
  },
};
</script>
